import { generateId } from '@freelancer/datastore/testing/helpers';
import type {
  UserConsent,
  UserConsentCollectionLocation,
  UserConsentDataType,
  UserConsentUsageType,
} from './user-consent.model';

export interface GenerateUserConsentOptions {
  readonly collectionLocation?: UserConsentCollectionLocation;
  readonly consentGiven?: boolean;
  readonly dataType?: UserConsentDataType;
  readonly usageType?: UserConsentUsageType;
  readonly dateCreated?: number;
}

export function generateUserConsentObject({
  dataType = 'tracking',
  usageType = 'marketing',
  consentGiven = true,
  collectionLocation = 'consent_banner',
  dateCreated = Date.now(),
}: GenerateUserConsentOptions): UserConsent {
  return {
    id: generateId(),
    dataType,
    usageType,
    consentGiven,
    collectionLocation,
    dateCreated,
  };
}
